export const FETCH_ACTIVE_STUDENT_TYPES = 'FETCH_ACTIVE_STUDENT_TYPES';
export const FETCH_CURRENT_STUDENT_TYPE = 'FETCH_CURRENT_STUDENT_TYPE';
